// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_identity_pool_id: "us-east-2:08c3e5be-d611-4807-8a37-6388c6d66132",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_Y0Bn9xKRE",
  aws_user_pools_web_client_id: "1nvuo52mf6cvkqci5q40ekillk",
  oauth: {},
  federationTarget: "COGNITO_IDENTITY_POOLS",
  aws_user_files_s3_bucket: "patient-portal-production-storage",
  aws_user_files_s3_bucket_region: "us-east-2",
  aws_user_files: "enable"
};

export default awsmobile;
